import _ from 'lodash';
import {
  FETCH_USER_MAILBOX_SELECTIONS_SUCCESS,
  SAVE_USER_MAILBOX_SELECTION_REQUEST,
  DELETE_USER_MAILBOX_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import postalOperatorsMapper from '../mappers/postalOperatorsMapper';
import {
  DEPARTURE_MAILBOX_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED,
  DESELECT_ALL_DEPARTURE_MAILBOXES,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE,
  SELECT_ALL_DEPARTURE_MAILBOXES,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_MAILBOX_ADMIN,
} from '../actions/types/DeparturePostalOperatorActionTypes';
import filterEdiMailboxesIfExistsInPostalOperators from '../filters/filterEdiMailboxesIfExistsInPostalOperators';
import { SWITCH_DEPARTURE_ARRIVAL } from '../actions/types/PostalOperatorActionTypes';
import OperatorTypes from '../../../../common/redux/actions/types/OperatorTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import {
  DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST,
  SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST,
} from '../../../../admin/dashboard/redux/actions/types/AdminDashboardActionTypes';

export const initialState = {
  nodes: [],
  checkedMailboxes: [],
  expandedPostalOperators: [],
  expandedPostalOperatorsMailboxAdmin: [],
  selections: [],
  isLoading: false,
};

const allChildNodeValues = nodes =>
  nodes.map(node => node.children.map(mPC => mPC.value))
    .reduce((initial, ediMailboxes) => initial.concat(ediMailboxes));

const handleUserMailboxSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    ediMailboxes: action.payload.selectedEdiMailboxes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminMailboxSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    ediMailboxes: action.payload.selectedEdiMailboxes,
    scope: 'GLOBAL',
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserMailboxSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminMailboxSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const departurePostalOperatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_MAILBOX_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.DEPARTURE) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map(selection => ({
              ...selection,
              name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS:
      return {
        ...state,
        nodes: postalOperatorsMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case DEPARTURE_MAILBOX_CHECKED:
      return {
        ...state,
        checkedMailboxes: filterEdiMailboxesIfExistsInPostalOperators(
          action.checkedMailboxes,
          state.nodes,
          action.reportDefinition,
        ),
      };
    case DEPARTURE_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedPostalOperators: [...action.expandedPostalOperators],
      };
    case DEPARTURE_POSTAL_OPERATOR_EXPANDED_MAILBOX_ADMIN:
      return {
        ...state,
        expandedPostalOperatorsMailboxAdmin: [...action.expandedPostalOperatorsMailboxAdmin],
      };
    case SELECT_ALL_DEPARTURE_MAILBOXES:
      return {
        ...state,
        checkedMailboxes: allChildNodeValues(action.payload.nodes),
      };
    case DESELECT_ALL_DEPARTURE_MAILBOXES:
      return {
        ...state,
        checkedMailboxes: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_MAILBOX_SELECTION_REQUEST:
      return handleUserMailboxSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST:
      return handleAdminMailboxSelectionRequest(action, state);
    case DELETE_USER_MAILBOX_SELECTION_REQUEST:
      return handleUserMailboxSelectionDeleteRequest(action, state);
    case DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST:
      return handleAdminMailboxSelectionDeleteRequest(action, state);
    case SWITCH_DEPARTURE_ARRIVAL:
      return {
        ...state,
        ...action.payload.arrival,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
